<template>
  <div id="shop-item-price">
    <v-container grid-list-xl>
      <v-layout align-center justify-center row wrap>
        <v-flex :key="state.idx" py-1 v-for="state in states" xs11>
          <v-card class="card-price" @click="viewPrice(state)" elevation="0">
            <v-card-text>
              <v-layout align-center row text-xs-center wrap>
                <v-flex xs7>
                  <div class="body-2">{{ state.name }}</div>
                </v-flex>
                <v-flex pl-0 xs5>
                  <div class="body-2 font-weight-bold">{{ `${state.price} บาท` }}</div>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex pt-0 xs11>** ค่าจัดส่งในกรุงเทพฯ ฟรี!!</v-flex>
      </v-layout>
    </v-container>
    <v-dialog max-width="400px" scrollable v-model="dialogItem">
      <v-card>
        <v-card-text>
          <v-layout align-center justify-center row text-xs-center wrap>
            <v-flex v-if="items" xs12>
              <v-card class="card-price" elevation="0">
                <v-card-text>
                  <v-layout align-center row text-xs-center wrap>
                    <v-flex xs7>
                      <div class="subheading">{{ items.name }}</div>
                    </v-flex>
                    <v-flex pl-0 xs5>
                      <div class="subheading font-weight-bold">{{ `${items.price} บาท` }}</div>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12>
              <v-btn
                block
                @click.prevent="doAddCarts(items)"
                color="primary"
                dark
                depressed
              >ใส่ตะกร้า</v-btn>
            </v-flex>
            <!-- <v-flex xs12>
              <v-btn block @click.prevent="doCheckout(items)" color="green" dark depressed
                >สั่งซื้อ</v-btn
              >
            </v-flex>-->
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'shop-item-price',
  props: {
    shopEditionProductItemId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dialogItem: false,
      items: []
    }
  },
  computed: {
    states() {
      return this.$store.getters['ShopEditionProductItemPrice/getAll'].filter(
        item => item.shopEditionProductItemId == this.shopEditionProductItemId
      )
    }
  },
  created() {
    this.$store.dispatch('ShopEditionProductItemPrice/fetch')
  },
  methods: {
    viewPrice(state) {
      this.items = state
      this.dialogItem = !this.dialogItem
    },
    doAddCarts(itemPrice) {
      this.$store.dispatch('Cart/addToCart', itemPrice)
      this.dialogItem = !this.dialogItem
    },
    doCheckout(itemPrice) {
      this.$store.dispatch('Cart/addToCart', itemPrice)
      this.dialogItem = !this.dialogItem
      this.$router.push({ name: 'shop-checkout' })
    }
  }
}
</script>

<style lang="scss" scoped>
.card-price {
  border: 3px solid #00b050;
}
</style>
